import { Col, Row } from "antd";
import React, { Fragment } from "react";
import Card from "./Card/Card";
import NoData from "../../common/cards/noData";
const Followers = ({ data, setData }) => {
  const activedata = data?.filter((e) => e.accept);
  return (
    <Fragment>
      <Row gutter={[15, 0]}>
        {activedata?.length > 0 ? (
          activedata?.map((e, i) => (
            <Col
              key={i}
              xxl={6}
              xl={8}
              lg={{ span: 12 }}
              md={{ span: 12 }}
              sm={24}
              xs={24}
              style={{
                display: "flex"
              }}>
              <Card type={"primary"} setData={setData} data={e} buttonText="Follow" />
            </Col>
          ))
        ) : (
          <Col span={24}>
            <NoData noMedia />
          </Col>
        )}
      </Row>
      {/* <RequestCard />
      <RequestCard /> */}
    </Fragment>
  );
};

export default Followers;
